import { Vertex3 } from '../vertex/vertex-3.class';

export const translateYCfn = (point: Vertex3, angle: number, originIn: Vertex3 | null = null): void => {
	const origin = originIn === null ? new Vertex3({ dataIn: { x: 0, y: 0, z: 0 }}) : originIn;

	// Translate the points so that the origin is at the point you want to rotate around.
	const translatedPoint = { x: point.x - origin.x, y: point.y - origin.y, z: point.z - origin.z };

	// Rotate the points by the desired angle.
	const rotatedPoint = {
		x: (translatedPoint.x * Math.cos(angle)) - (translatedPoint.y * Math.sin(angle)),
		y: (translatedPoint.x * Math.sin(angle)) + (translatedPoint.y * Math.cos(angle)),
		z: translatedPoint.z
	};

	// Translate the points back to their original position.
	point.x = rotatedPoint.x + origin.x;
	point.y = rotatedPoint.y + origin.y;
	point.z = rotatedPoint.z + origin.z;
}
